import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BlockerState {
  forceBlock: boolean;
  blockerCallbacks: {
    onConfirm?: () => void;
    onCancel?: () => void;
    message?: string;
    confirmLabel?: string;
    cancelLabel?: string;
  };
}

const initialState: BlockerState = {
  forceBlock: false,
  blockerCallbacks: {}
};

const pageBlockerSlice = createSlice({
  name: 'pageBlocker',
  initialState,
  reducers: {
    // setFormDirty: (state) => {
    //   state.isDirty = true;
    // },
    // setFormClean: (state) => {
    //   state.isDirty = false;
    // },
    showPageBlocker: (state, action: PayloadAction<BlockerState['blockerCallbacks']>) => {
      state.forceBlock = true;
      state.blockerCallbacks = action.payload;
    },
    hidePageBlocker: (state) => {
      state.forceBlock = false;
      state.blockerCallbacks = {};
    }
  }
});
export const {  showPageBlocker, hidePageBlocker } = pageBlockerSlice.actions;

export default pageBlockerSlice.reducer;
